import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import UIGrid from 'UIComponents/grid/UIGrid';
import UIGridItem from 'UIComponents/grid/UIGridItem';
export default function ReviewWizardGrid({
  children
}) {
  return /*#__PURE__*/_jsxs(UIGrid, {
    className: "p-top-4",
    children: [/*#__PURE__*/_jsx(UIGridItem, {
      size: {
        xs: 0,
        md: 1,
        lg: 3
      }
    }), /*#__PURE__*/_jsx(UIGridItem, {
      size: {
        xs: 12,
        md: 10,
        lg: 6
      },
      children: children
    }), /*#__PURE__*/_jsx(UIGridItem, {
      size: {
        xs: 0,
        md: 1,
        lg: 3
      }
    })]
  });
}